export default {
    init() {
        var $ = window.$;

        function addInputMaskToPhone() {
            if ($("[data-inputmask]").length) {
                var $inputMaskElements = $('[data-inputmask]');
                $inputMaskElements.each(function () {
                    var $inputMaskElement = $(this);

                    $inputMaskElement.on('dragstart drop', function (e) {
                        e.preventDefault();
                    });

                    if ($inputMaskElement.attr('placeholder') !== undefined &&
                        ($inputMaskElement.attr('placeholder').toLowerCase().indexOf('+7') >= 0 ||
                            $inputMaskElement.attr('placeholder').toLowerCase().indexOf('телефон') >= 0 ||
                            $inputMaskElement.attr('placeholder').toLowerCase().indexOf('логин') >= 0)) {

                        if ($inputMaskElement.attr('data-inputmask-init') !== 'init') {

                            if ($inputMaskElement.val().length === 10) {
                                $inputMaskElement.val('7' + $inputMaskElement.val());
                            }
                            $inputMaskElement.inputmask({
                                mask: '+* (999) 999-99-99',
                                onBeforeWrite: function (ev) {
                                    var target = ev.target;
                                    var isAndroid = navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1;
                                    /**
                                     * Fix бага на android |start|
                                     */
                                    if (isAndroid && typeof target === 'undefined' && ev.type === 'keypress') {
                                        target = $inputMaskElement[0];
                                    }
                                    /**
                                     * Fix бага на android |end|
                                     */
                                    if (target !== undefined) {
                                        var value = target.value && target.value.replace(/[^\d]/g, '');
                                        if (value) {
                                            var intValue = parseInt(value);
                                            var strValue = String(intValue);

                                            if (strValue.length === 1) {
                                                if (intValue === 7) {
                                                    // do nothing
                                                } else if (intValue === 8) {
                                                    setTimeout(function () {
                                                        target.value = '7';
                                                    }, 0);
                                                } else {
                                                    setTimeout(function () {
                                                        target.value = '7' + value;
                                                    }, 0);
                                                }
                                            } else if (strValue.length > 1) {
                                                var newVal;

                                                if (parseInt(value[0]) === 7 || parseInt(value[0]) === 8) {
                                                    newVal = '7' + value.substr(1, value.length);
                                                } else {
                                                    newVal = '7' + value;
                                                }

                                                if (newVal !== strValue) {
                                                    setTimeout(function () {
                                                        target.value = newVal;
                                                    }, 0);
                                                }
                                            }
                                        }
                                    }
                                    return ev;
                                },
                                definitions: {
                                    '*': {
                                        validator: function (chrs, buffer, pos) {
                                            var valExp2 = new RegExp("[0-9]");
                                            return valExp2.test(buffer[pos - 1] + chrs);
                                        },
                                    },
                                    '7': {
                                        validator: function (chrs, buffer, pos) {
                                            var valExp2 = new RegExp("[7-8]");
                                            return valExp2.test(buffer[pos - 1] + chrs);
                                        },
                                    },
                                },
                                showMaskOnHover: false,
                            });
                            $inputMaskElement.attr('data-inputmask-init', 'init');
                        }
                    } else {
                        $inputMaskElement.inputmask({
                            showMaskOnHover: false,
                        });
                    }
                });
            }
        }

        // Preloader
        function preloaderDots() {
            return '' +
                '<div class="preloader sk-circle">\n' +
                '        <div class="sk-circle1 sk-child"></div>\n' +
                '        <div class="sk-circle2 sk-child"></div>\n' +
                '        <div class="sk-circle3 sk-child"></div>\n' +
                '        <div class="sk-circle4 sk-child"></div>\n' +
                '        <div class="sk-circle5 sk-child"></div>\n' +
                '        <div class="sk-circle6 sk-child"></div>\n' +
                '        <div class="sk-circle7 sk-child"></div>\n' +
                '        <div class="sk-circle8 sk-child"></div>\n' +
                '        <div class="sk-circle9 sk-child"></div>\n' +
                '        <div class="sk-circle10 sk-child"></div>\n' +
                '        <div class="sk-circle11 sk-child"></div>\n' +
                '        <div class="sk-circle12 sk-child"></div>\n' +
                '</div>';
        }

        $(document).on('click', '[data-popup=paymentService]', function () {
            var $this = $(this);
            var $popup = $('.popup-payment');
            var $price = Number($this.attr('data-price'));
            var $serviceID = $this.data('service-id');
            var $clinicName = $this.data('selected-clinic');

            if ($popup.length === 0) {
                var popPayment = document.createElement('div');
                popPayment.classList.add('popup-payment');
                var appendBlock = document.querySelector('root') || document.querySelector('body');
                appendBlock.appendChild(popPayment);
                $popup = $('.popup-payment');
            }

            var $body = $('body');
            var $source = $(this).data('href');

            var loadContent = function () {
                $popup
                    .append(preloaderDots())
                    .load($source, {
                        'price': $price,
                        'service_id': $serviceID,
                        'clinicName': $clinicName,
                    }, function () {
                        $popup.remove('.preloader');
                        addInputMaskToPhone();
                    });
            };

            if ($.magnificPopup.instance.isOpen) {
                loadContent();
            } else {
                $.magnificPopup.open({
                    alignTop: false,
                    fixedContentPos: true,
                    fixedBgPos: true,
                    closeBtnInside: true,
                    closeOnBgClick: false,
                    overflowY: 'auto',
                    removalDelay: 300,
                    mainClass: 'popup-payment-wrapper',
                    type: 'inline',
                    items: {
                        src: '.popup-payment',
                    },
                    callbacks: {
                        open: function () {
                            $body.css('overflow', 'hidden');

                            if ($(window).width() < 768) {
                                $body.css('top', $(document).scrollTop() * -1).addClass('fixed-body');
                            } else {
                                $body.addClass('background-fixed k50-indent'); // Fix for Android Chrome
                            }

                            loadContent();
                        },
                        close: function () {
                            var offset;

                            $body.css('overflow', '');

                            if ($body.hasClass('background-fixed')) {
                                $body.removeClass('background-fixed');
                            }
                            if ($body.hasClass('fixed-body')) {
                                offset = parseInt(document.body.style.top, 10);

                                $body.removeClass('fixed-body').css('top', '');
                                $(document).scrollTop(offset * -1);
                            }
                            if ($body.hasClass('k50-indent')) {
                                $body.removeClass('k50-indent');
                            }

                            $popup.remove('.preloader');
                        },
                    },
                });
            }
        });
    },
};
